export class InvalidLicenseIdException extends Error {

}
